module.exports = __webpack_public_path__ + "static/image_13-383714e5e8420288abe936f675a0bec5.jpg";